import type { MouseEvent as ReactMouseEvent } from 'react';

/**
 * THE one rule for "this element is a real `<a>` AND the app routes it
 * client-side".
 *
 * Every navigating affordance in the product is an anchor with a real `href`
 * (`DataTable.rowHref`, `StatCell.href`, `EmptyState`'s action `href`, a
 * `<Button asChild><a>`), because that is the only way ⌘/Ctrl-click,
 * middle-click, right-click "Open in new tab" and the browser's hover preview
 * work at all. The router then takes over the PLAIN left-click and nothing
 * else — which is exactly what this predicate decides.
 *
 * Left the browser alone for: a modified click (⌘/Ctrl/Shift/Alt), a
 * non-primary button (middle-click is `button === 1`), and an event another
 * handler already claimed (`defaultPrevented`).
 *
 * Router-agnostic on purpose — `packages/shared` renders under react-router
 * (console, internal) AND Next.js (hosted), so the caller supplies the
 * navigation.
 */
export function interceptPlainClick(
  e: ReactMouseEvent<HTMLElement>,
  navigate?: (() => void) | null,
): void {
  if (!navigate || e.defaultPrevented || e.button !== 0) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  navigate();
}
